import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { MatCardModule } from '@angular/material/card';

import { DisabledPageComponent } from './disabled-page.component';

export const disabledPageRoutes: Routes = [
  {
    path: 'disabled/:pageKey',
    component: DisabledPageComponent,
  },
];

@NgModule({
  imports: [CommonModule, MatCardModule, RouterModule],
  declarations: [DisabledPageComponent],
  exports: [DisabledPageComponent],
})
export class DisabledPageModule {}
